import React, { useCallback } from "react";
import { Button, Icon } from "antd";

interface StudyBtnProps {
    onClick: () => void;
}

export default function StudyBtn({ onClick }: StudyBtnProps) {
    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            onClick();
        },
        [onClick]
    );

    return (
        <Button type="primary" ghost onClick={handleClick}>
            <Icon type="play-circle" /> 继续学习
        </Button>
    );
}
